import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { AdsBannerComponent } from './ads-banner.component';

@NgModule({
	declarations: [AdsBannerComponent],
	imports: [SharedModule],
	exports: [AdsBannerComponent],
})
export class AdsBannerModule {}
